import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import AppContainer from './app-container.js';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from 'react-router-dom'
import HttpsRedirect from 'react-https-redirect';

ReactDOM.render((
    <HttpsRedirect>
        <BrowserRouter>
            <AppContainer />
        </BrowserRouter>
    </HttpsRedirect>
), document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
